module.exports = __webpack_public_path__ + "img/7.85c0cfc1.png";